import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import check from '../../assets/feedback/check.svg'
import exclamation from '../../assets/feedback/exclamation.svg'
import cross from '../../assets/feedback/cross.svg'
import { MessageBox, MessageDiv, MessageHeader, MessageIcon, MessageStatus, MessageText, TipDiv } from './style'
import { FeedbackContext } from '../../contexts/FeedbackContext'

const FeedbackComponent: React.FC = () => {
  const { feedback, setFeedback } = useContext(FeedbackContext)
  const { message, statusOk, title, semTitulo } = feedback
  const displayStatus = title || (statusOk ? 'Sucesso' : 'Algo inesperado aconteceu')

  const content = (
    <MessageBox className={statusOk ? '' : 'error'}>
      <MessageHeader onClick={() => setFeedback({ isOpen: false, message: '', statusOk: true })}>
        <img src={cross} alt="cross icon" />
      </MessageHeader>
      <MessageDiv>
        <MessageIcon src={statusOk ? check : exclamation} alt="check icon" draggable='false' />
        <TipDiv>
          {!(semTitulo && !statusOk && !title) && <MessageStatus>{displayStatus}</MessageStatus>}
          <MessageText>{message}</MessageText>
        </TipDiv>
      </MessageDiv>
    </MessageBox>
  )

  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(content, document.body)
  }

  return content
}

export default FeedbackComponent